<div class="w-full">
  <div class="dot-indicators flex justify-center">
    @for (slide of slides(); track slide.title ?? slide.type) {
      <div class="dot" [class.active]="$index === activeSlideIndex()" (click)="goToSlide.emit($index)"></div>
    }
  </div>
  <div class="flex flex-col justify-center items-center">
    <div class="flex w-full justify-center mt-10 mb-8 md:mt-12 md:mb-10 items-center gap-8 md:gap-10 navigation-button">
      <button
        class="cursor-pointer button-prev"
        type="button"
        [attr.aria-label]="'common.back' | translate"
        [disabled]="isPrevDisabled()"
        (click)="onPrevClick.emit()"
        (touchstart)="preventEvent($event)"
        (touchmove)="preventEvent($event)"
        (touchend)="preventEvent($event)"
      >
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
            <path
              d="M14.3103 26.3873C14.7101 26.7683 15.3432 26.7528 15.7241 26.3529C16.1051 25.9531 16.0896 25.32 15.6897 24.9391L7.35449 16.9996H27C27.5523 16.9996 28 16.5519 28 15.9996C28 15.4473 27.5523 14.9996 27 14.9996H7.35436L15.6897 7.06003C16.0896 6.67911 16.1049 6.04613 15.7241 5.64623C15.3432 5.24633 14.7101 5.23093 14.3103 5.61185L4.41839 15.0341C4.19315 15.2487 4.05988 15.5223 4.01857 15.8068C4.00639 15.8692 4 15.9337 4 15.9996C4 16.0657 4.00641 16.1303 4.01864 16.1928C4.06003 16.4772 4.19328 16.7507 4.41839 16.9651L14.3103 26.3873Z"
              fill="#FCFCFC"
            />
          </svg>
        </i>
      </button>
      <button
        class="cursor-pointer button-next"
        type="button"
        [attr.aria-label]="'common.next' | translate"
        [disabled]="isNextDisabled()"
        (click)="onNextClick.emit()"
        (touchstart)="preventEvent($event)"
        (touchmove)="preventEvent($event)"
        (touchend)="preventEvent($event)"
      >
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
            <path
              d="M17.6897 5.61185C17.2899 5.23093 16.6568 5.24633 16.2759 5.64623C15.8949 6.04613 15.9104 6.67911 16.3103 7.06003L24.6455 14.9995H5C4.44772 14.9995 4 15.4472 4 15.9995C4 16.5517 4.44772 16.9995 5 16.9995H24.6456L16.3103 24.9391C15.9104 25.32 15.8949 25.9531 16.2759 26.3529C16.6568 26.7528 17.2899 26.7683 17.6897 26.3873L27.5816 16.9651C27.8068 16.7505 27.9401 16.4768 27.9815 16.1924C27.9936 16.13 28 16.0655 28 15.9995C28 15.9335 27.9936 15.8688 27.9813 15.8063C27.94 15.522 27.8067 15.2485 27.5816 15.0341L17.6897 5.61185Z"
              fill="#FCFCFC"
            />
          </svg>
        </i>
      </button>
    </div>
    @if (isTutorial()) {
      <p class="paragraph-medium outfit cursor-pointer light close-tutorial" (click)="goToOkeeyCash()">
        {{ 'okeeyCash.closeTutorial' | translate }}
      </p>
    }
    @if (isJourney()) {
      <p class="paragraph-medium outfit cursor-pointer light close-tutorial" (click)="goToOkeeyCash()">
        {{ 'okeeyCash.close' | translate }}
      </p>
    }
  </div>
</div>
